<template>
    <div>
        <div v-show="flag"></div>
        <div class="search-box search-box1">
            <div class="input-item">
                <span class="label"><span class="star">*</span>统计机构</span>
                <selectTree :clearable="false" v-model="search.organizationId" type="3" @change="changeSelect1" ref="selectTreeRef"> </selectTree>
            </div>

            <div class="input-item-01">
                <span class="star">*</span>
                <span class="label">统计周期</span>
                <div class="cycle">
                    <div
                        class="tab"
                        :class="{ active: item.value == cycleActiveIndex }"
                        @click="clickCycle(item.value)"
                        v-for="item in cycleList"
                        :key="item.value"
                    >
                        <a>{{ item.label }}</a>
                    </div>
                </div>
                <DatePicker
                    v-show="cycleActiveIndex == 1"
                    style="width: 240px"
                    :clearable="false"
                    type="daterange"
                    split-panels
                    separator="至"
                    placement="bottom"
                    v-model="search.validDate"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @on-ok="changeDatePicker1"
                    @on-change="changeDatePicker1"
                    :options="optionsStartDay"
                    :confirm="true"
                    ref="DatePicker1"
                >
                </DatePicker>
                <span class="tips1" v-if="result1">* 统计周期最长为60天</span>
                <span class="tips1" v-if="result2">* 统计周期最短为3个月</span>
                <span class="tips1" v-if="result3">* 统计周期最多为36个月</span>

                <DatePicker
                    v-show="cycleActiveIndex == 2"
                    style="width: 115px"
                    :clearable="false"
                    type="month"
                    split-panels
                    :transfer="true"
                    placement="bottom"
                    v-model="search.startDate"
                    format="yyyy-MM"
                    placeholder="开始日期"
                    @on-ok="changeDatePicker('DatePicker2')"
                    @on-change="changeDatePicker('DatePicker2')"
                    :options="optionsStopMonth"
                    :confirm="true"
                    ref="DatePicker2"
                >
                </DatePicker>
                <span v-if="cycleActiveIndex == 2" style="margin: 0 5px">至</span>
                <DatePicker
                    v-show="cycleActiveIndex == 2"
                    style="width: 115px"
                    :clearable="false"
                    type="month"
                    split-panels
                    :transfer="true"
                    placement="bottom"
                    v-model="search.endDate"
                    format="yyyy-MM"
                    placeholder="结束日期"
                    @on-ok="changeDatePicker('DatePicker2')"
                    @on-change="changeDatePicker('DatePicker2')"
                    :options="optionsStopMonth"
                    :confirm="true"
                    ref="DatePicker3"
                >
                </DatePicker>
            </div>
        </div>
        <div class="search-box">
            <div class="input-item">
                <span class="label">长短险</span>
                <Select v-model="search.productType" clearable @on-change="changeLongshort" @on-clear="changeDatePicker">
                    <Option value="1">长险</Option>
                    <Option value="2">短险</Option>
                </Select>
            </div>

            <div class="input-item">
                <span class="label">险种分类</span>
                <Select v-model="search.themeId" clearable filterable @on-change="changeBusinessClass" @on-clear="changeDatePicker">
                    <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
                </Select>
            </div>

            <div class="input-item">
                <span class="label">添加比较对象</span>
                <Select v-model="search.groupIds" :multiple="true" clearable @on-change="changeSelect2" :max-tag-count="1">
                    <Option v-for="(item, i) in groupList" :key="i" :value="item.groupId">{{ item.groupName }}-{{ item.groupCode }}</Option>
                </Select>
            </div>
        </div>

        <div class="echarts-container">
            <div class="echarts-item">
                <div class="item-top">
                    <span class="title">业绩趋势</span>
                    <div class="action-btn">
                        <div
                            class="action-item"
                            :class="{ active: item.value == chartActionIndex }"
                            v-for="item in chartAction"
                            :key="item.value"
                            @click="clickEchBtn1(item.value)"
                        >
                            {{ item.label }}
                        </div>
                    </div>
                </div>
                <div class="echarts-box">
                    <div class="date-unit">
                        <span v-if="chartActionIndex == 1">单位：件</span>
                        <span v-else>单位：元</span>
                    </div>
                    <div ref="chart1" style="width: 100%; height: 90%"></div>
                </div>
            </div>

            <div class="echarts-item">
                <div class="item-top">
                    <span class="title">件均趋势</span>
                    <div class="action-btn">
                        <div v-for="item in chartAction" :key="item.value">
                            <div
                                class="action-item"
                                :class="{ active: item.value == chartActionIndex2 }"
                                @click="clickEchBtn2(item.value)"
                                v-if="item.value!=1"
                            >
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="echarts-box">
                    <div class="date-unit">
                        <span v-if="chartActionIndex2 == 1">单位：件</span>
                        <span v-else>单位：元</span>
                    </div>
                    <div ref="chart2" style="width: 100%; height: 90%"></div>
                </div>
            </div>

            <div class="echarts-item">
                <div class="item-top">
                    <span class="title">客均趋势</span>
                    <div class="action-btn">
                        <div
                            class="action-item"
                            :class="{ active: item.value == chartActionIndex3 }"
                            v-for="item in chartAction"
                            :key="item.value"
                            @click="clickEchBtn3(item.value)"
                        >
                            {{ item.label }}
                        </div>
                    </div>
                </div>
                <div class="echarts-box">
                    <div class="date-unit">
                        <span v-if="chartActionIndex3 == 1">单位：件</span>
                        <span v-else>单位：元</span>
                    </div>
                    <div ref="chart3" style="width: 100%; height: 90%"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import filters from '@/api/filter';
import * as echarts from 'echarts';

export default {
    name: 'team',
    components: { selectTree },
    filters,
    data() {
        let _this = this;
        return {
            search: {
                organizationId: '',
                groupIds: [],
                type: 2 //类型 (1 机构 2 团队 3 渠道)
            },
            orgType: '', //数据范围当前选中的是否为机构/团队/渠道(1、商户，2、3、4机构，5渠道)
            themeList: [],
            groupList: [], //团队
            cycleActiveIndex: 1,
            cycleList: [
                {
                    label: '按日',
                    value: '1'
                },
                {
                    label: '按月',
                    value: '2'
                }
            ],
            chartAction: [
                {
                    label: '件数',
                    value: '1'
                },
                {
                    label: '规模保费',
                    value: '2'
                },
                {
                    label: '标准保费',
                    value: '3'
                }
            ],
            chartActionIndex: 3,
            chartActionIndex2: 3,
            chartActionIndex3: 3,
            chart1: null,
            chart2: null,
            chart3: null,
            optionsStartDay: {
                disabledDate(date) {
                    return filters.filterTime(date, 'YYYY-MM-DD') > filters.filterTime(_this.dateCalc(0), 'YYYY-MM-DD');
                }
            },
            optionsStopMonth: {
                disabledDate(date) {
                    return filters.filterTime(date, 'YYYY-MM') > filters.filterTime(_this.dateCalc(0), 'YYYY-MM');
                }
            },
            flag:false,
            result1: false,
            result2: false,
            result3: false
        };
    },
    created() {
        this.dateSet();
        this.search.organizationId = JSON.parse(localStorage.userInfo).organId;
        this.$nextTick(() => {
            this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
        });
        this.queryTheme();
        this.initData1();
        this.initData2();
        this.initData3();
    },

    mounted() {
        // 监听页面滚动事件、解决图表加载缓慢问题
        window.addEventListener("scroll", this.scrolling);
        this.$nextTick(()=>{
            document.querySelectorAll('.ivu-btn-default')[0].style = 'display:none;';
            document.querySelectorAll('.ivu-btn-default')[1].style = 'display:none;';
            document.querySelectorAll('.ivu-btn-default')[2].style = 'display:none;';
        })
    },

    methods: {
        scrolling() {
            if(this.flag){
                this.flag = !this.flag;
            }else{
                this.flag = !this.flag;
            }
        },

        dateSet() {
            const dayStart = filters.filterTime(this.dateCalc(-30), 'YYYY-MM-DD');
            const dayEnd = filters.filterTime(this.dateCalc(0), 'YYYY-MM-DD');
            this.$set(this.search, 'validDate', [dayStart, dayEnd]);
        },

        // 计算时间日期
        dateCalc(num = 1, date = false) {
            if (!date) {
                date = new Date(); //没有传入值时,默认是当前日期
                date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            }
            date += ' 00:00:00'; //设置为当天凌晨12点
            date = Date.parse(new Date(date)) / 1000; //转换为时间戳
            date += 86400 * num; //修改后的时间戳
            var newDate = new Date(parseInt(date) * 1000); //转换为时间
            return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
        },

        // 获取团队列表
        queryGroupList() {
            this.$http({
                url: '/buz/organizationGroup/getSubGroup',
                type: 'get',
                data: {
                    organizationId: this.search.organizationId,
                    queryTop:1
                }
            }).then(res => {
                this.groupList = res.data;
                this.search.groupIds =  res.data.map(item=>item.groupId);
            });
        },

        // 险种分类
        queryTheme() {
            this.$http({
                url: '/buz/productTheme/array/first',
                type: 'GET'
            }).then(res => {
                this.themeList = res.data;
            });
        },

        setRequestParam() {
            let obj = JSON.parse(JSON.stringify(this.search));
            obj.searchDateType = this.cycleActiveIndex;
            obj.queryType = this.chartActionIndex;
            if (obj.searchDateType == 1) {
                if (obj.validDate && obj.validDate[0]) {
                    obj.startDate = filters.filterTime(obj.validDate[0], 'YYYY-MM-DD');
                    obj.endDate = filters.filterTime(obj.validDate[1], 'YYYY-MM-DD');
                }
            } else {
                obj.startDate = filters.filterTime(obj.startDate, 'YYYY-MM');
                obj.endDate = filters.filterTime(obj.endDate, 'YYYY-MM');
            }
            delete obj.validDate;
            delete obj.organizationId;
            let { ...params } = obj;
            return params;
        },

        // 随机取颜色值
        generateColor() {
            let colors = [
                '#5391FF',
                '#3AD0BD',
                '#FDBB52',
                '#FC716D',
                '#7485E5',
                '#87CA8B',
                '#FDA176',
                '#6BA9F6',
                '#94BB5F',
                '#33BBDB',
                '#8E77EB',
                '#FC6CC1',
                '#EF7C8C',
                '#198ADD',
                '#BDB01F',
                '#F1904B',
                '#2AB29F',
                '#AA5694',
                '#579F76',
                '#D0982F'
            ];
            let index = Math.floor(Math.random() * colors.length);
            return colors[index];
        },

        // 业绩趋势
        initData1() {
            if (this.chart1 != null && this.chart1 != '' && this.chart1 != undefined) {
                this.chart1.dispose(); //销毁
            }
            let data = {
                ...this.setRequestParam(),
                trendType: 1, //业绩趋势
                queryType: this.chartActionIndex,
            };
            this.$http({
                url: '/buz/dataCenter/queryTrendStatistics',
                type: 'PUT',
                data
            }).then(res => {
                let series = res.data.data.map(item => {
                    return {
                        name: item.name,
                        type: 'line',
                        data: item.data,
                        typeId: item.typeId,
                        smooth: true,
                        itemStyle: {
                            color: this.generateColor() //设置折线图颜色
                        }
                    };
                });
                let option = {
                    tooltip: {
                        trigger: 'axis',
                        confine: true,
                    },
                    legend: {
                        x: 'left',
                        padding: [0, 0, 0, 90],
                        data: res.data.name
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {},
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: res.data.payTime
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: series
                };
                this.chart1 = echarts.init(this.$refs.chart1);
                this.chart1.setOption(option);
                window.addEventListener('resize', () => {
                    this.chart1.resize();
                });
            });
        },

        // 业绩趋势
        initData2() {
            if (this.chart2 != null && this.chart2 != '' && this.chart2 != undefined) {
                this.chart2.dispose(); //销毁
            }
            let data = {
                ...this.setRequestParam(),
                trendType: 2, //件均趋势
                queryType: this.chartActionIndex2
            };
            this.$http({
                url: '/buz/dataCenter/queryTrendStatistics',
                type: 'PUT',
                data
            }).then(res => {
                let series = res.data.data.map(item => {
                    return {
                        name: item.name,
                        type: 'line',
                        data: item.data,
                        typeId: item.typeId,
                        smooth: true,
                        itemStyle: {
                            color: this.generateColor() //设置折线图颜色
                        }
                    };
                });
                let option = {
                    tooltip: {
                        trigger: 'axis',
                        confine: true,
                    },
                    legend: {
                        x: 'left',
                        padding: [0, 0, 0, 90],
                        data: res.data.name
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {},
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: res.data.payTime
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: series
                };
                this.chart2 = echarts.init(this.$refs.chart2);
                this.chart2.setOption(option);
                window.addEventListener('resize', () => {
                    this.chart2.resize();
                });
            });
        },

        // 客均趋势
        initData3() {
            if (this.chart3 != null && this.chart3 != '' && this.chart3 != undefined) {
                this.chart3.dispose(); //销毁
            }
            let data = {
                ...this.setRequestParam(),
                trendType: 3, //客均趋势
                queryType: this.chartActionIndex3
            };
            this.$http({
                url: '/buz/dataCenter/queryTrendStatistics',
                type: 'PUT',
                data
            }).then(res => {
                let series = res.data.data.map(item => {
                    return {
                        name: item.name,
                        type: 'line',
                        data: item.data,
                        typeId: item.typeId,
                        smooth: true,
                        itemStyle: {
                            color: this.generateColor() //设置折线图颜色
                        }
                    };
                });
                let option = {
                    tooltip: {
                        trigger: 'axis',
                        confine: true,
                    },
                    legend: {
                        x: 'left',
                        padding: [0, 0, 0, 90],
                        data: res.data.name
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {},
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: res.data.payTime
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: series
                };
                this.chart3 = echarts.init(this.$refs.chart3);
                this.chart3.setOption(option);
                window.addEventListener('resize', () => {
                    this.chart3.resize();
                });
            });
        },

        // 不符合规则提示语
        resultMsg() {
            if(this.result1){
                this.$Message.error('统计周期最长为60天');
            }else if(this.result2) {
                this.$Message.error('统计周期最短为3个月');
            }else if(this.result3) {
                this.$Message.error('统计周期最多为36个月');
            }
        },

        // 选择统计机构
        changeSelect1(data) {
            this.search.groupIds = [];
            this.queryGroupList();
        },

        // 选择比较对象
        changeSelect2(data) {
            if(this.cycleActiveIndex == 1){
                if (filters.getDiffDay(this.search.validDate[0], this.search.validDate[1]) > 60) {
                    this.result1 = true;
                } else {
                    this.result1 = false;
                    this.initData1();
                    this.initData2();
                    this.initData3();
                }
            }else{
                if(this.result2){
                    this.$Message.error('统计周期最短为3个月');
                    return
                }else if(this.result2) {
                    this.$Message.error('统计周期最多为36个月');
                }
                this.initData1();
                this.initData2();
                this.initData3();
            }
            this.resultMsg();
        },

        // 按日统计周期
        changeDatePicker1(date) {
            if (filters.getDiffDay(this.search.validDate[0], this.search.validDate[1]) > 60) {
                this.result1 = true;
                this.$refs.DatePicker1.visible = true;
                this.$Message.error('统计周期最长为60天');
            }else{
                this.result1 = false;
                this.initData1();
                this.initData2();
                this.initData3();
            }
        },

        // 改变长短险
        changeLongshort(data) {
            if(data){
                delete this.search.themeId; 
                if(this.cycleActiveIndex == 1){
                    if (filters.getDiffDay(this.search.validDate[0], this.search.validDate[1]) > 60) {
                        this.result1 = true;
                    } else {
                        this.result1 = false;
                        this.initData1();
                        this.initData2();
                        this.initData3();
                    }
                }
                this.resultMsg();
            }
        },

        // 改变业务分类
        changeBusinessClass(data) {
            if(data){
                delete this.search.productType;       
                if(this.cycleActiveIndex == 1){
                    if (filters.getDiffDay(this.search.validDate[0], this.search.validDate[1]) > 60) {
                        this.result1 = true;
                    } else {
                        this.result1 = false;
                        this.initData1();
                        this.initData2();
                        this.initData3();
                    }
                }
                this.resultMsg();
            }
        },

        // 按月统计周期
        changeDatePicker(key) {
            let days = filters.getDiffDay(this.search.startDate, this.search.endDate);
            if (days < 61) {
                this.$Message.error('统计周期最短为3个月');
                this.$refs[key].visible = true;
                this.result3 = false;
                this.result2 = true;
                return;
            }

            if (this.cycleActiveIndex == 2) {
                // 36个月
                if (days > 1094) {
                    this.$Message.error('统计周期最多为36个月');
                    this.$refs[key].visible = true;
                    this.result2 = false;
                    this.result3 = true;
                    return;
                }
            }
            
            this.result2 = false;
            this.result3 = false;
            this.initData1();
            this.initData2();
            this.initData3();
        },

        // 切换统计周期
        clickCycle(value) {
            this.cycleActiveIndex = value;
            if(value==2){
                const time = new Date();
                this.search.startDate = filters.filterTime(this.dateCalc(-337), 'YYYY-MM');
                this.search.endDate = filters.filterTime(time, 'YYYY-MM');
            }else{
                this.dateSet();
            }
            this.result1 = false;
            this.result2 = false;   
            this.result3 = false;
            this.initData1();
            this.initData2();
            this.initData3();
        },

        // 业绩趋势图标筛选
        clickEchBtn1(value) {
            this.chartActionIndex = value;
            this.initData1();
        },

        // 件均趋势图标筛选
        clickEchBtn2(value) {
            this.chartActionIndex2 = value;
            this.initData2();
        },

        clickEchBtn3(value) {
            this.chartActionIndex3 = value;
            this.initData3();
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box1 {
    padding-top: 20px;
}
.search-box {
    background: #fff;
    display: flex;
    padding-left: 20px;
}
.star {
    color: #E3461F;
    margin-right: 4px;
    margin-top: 2px;
}
.input-item-01 {
    height: 28px !important;
    position: relative;
    display: flex;
    align-items: center;
    min-width: 510px;
    height: 32px;
    .label {
        margin-right: 10px;
    }
    .tips1 {
        color: #ed4014;
        position: absolute;
        bottom: -20px;
        right: 110px;
        font-size: 14px;
    }
}

.cycle {
    display: flex;

    .tab {
        margin-right: 10px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #e3e5e8;
        border-radius: 2px;

        a {
            display: block;
            font-size: 13px;
            color: #515c6f;
        }

        &.active {
            background: #f4f7ff;
            border: 1px solid #236dff;

            a {
                color: #236dff;
            }
        }
    }
}

.echarts-container {
    margin-top: 10px;

    .echarts-item {
        margin-bottom: 10px;
        width: 100%;
        background-color: #fff;

        .item-top {
            margin-top: 10px;
            height: 52px;
            border-bottom: 1px solid #ececec;
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .title {
                font-size: 16px;
                color: #3c464f;
                font-weight: bold;
                letter-spacing: 0.5px;
            }

            .action-btn {
                display: flex;

                .action-item {
                    width: 80px;
                    height: 30px;
                    border: 1px solid #e3e5e8;
                    border-right: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #515c6f;
                    font-size: 12px;
                    background-color: #fff;

                    &.active {
                        background-color: #236dff;
                        border: none !important;
                        color: #fff;
                    }
                }

                .action-item:last-child {
                    border: 1px solid #e3e5e8;
                    border-radius: 0 2px 2px 0;
                }

                .action-item:first-child {
                    border-radius: 2px 0px 0px 2px;
                }

                .action-item:hover {
                    cursor: pointer;
                }
            }
        }

        .echarts-box {
            padding: 20px 0 0px 0;
            height: 400px;
            position: relative;
            .date-unit {
                position: absolute;
                top: 16px;
                left: 10px;
                padding: 0 20px;
                span {
                    font-size: 12px;
                    color: #727c8e;
                }
            }
        }
    }
}
</style>
